import type { DataGridFilterState, DataGridSortingState, TableFilterState, TableSortingState } from '@ibsys/kit';

/** Конвертирует фильтры из формата персистенции в формат DataGrid */
export const toDataGridFilters = (filters: TableFilterState): DataGridFilterState =>
  Object.fromEntries(filters.map(({ id, value }) => [id, value]));

/** Конвертирует фильтры из формата DataGrid в формат персистенции */
export const fromDataGridFilters = (filters: DataGridFilterState): TableFilterState =>
  Object.entries(filters).map(([id, value]) => ({ id, value }));

/** Конвертирует сортировку из формата персистенции в формат DataGrid */
export const toDataGridSorting = (sorting: TableSortingState): DataGridSortingState =>
  sorting.map(({ id, desc }) => ({ columnId: id, direction: desc ? ('desc' as const) : ('asc' as const) }));

/** Конвертирует сортировку из формата DataGrid в формат персистенции */
export const fromDataGridSorting = (sorting: DataGridSortingState): TableSortingState =>
  sorting.map(({ columnId, direction }) => ({ id: columnId, desc: direction === 'desc' }));
